import { readyForMTC } from "../../../../network/protocol/mainServer";
import type { MainServerMessage } from "../../../../network/protocol/mainServer/types";
import MessagesCommunication from "./messagesCommunication";

export default function sendReadyForMTC(
  connection: MessagesCommunication<MainServerMessage>,
) {
  connection.send(readyForMTC());
}
